<template>
  <v-container>
    <v-row>
      <v-col
        v-if="tutorial"
        cols="12"
        md="10"
        offset-md="1"
      >
        <h2 class="display-1 primary--text mb-2 long-title-wrap">
          {{ tutorial.title }}
        </h2>
        <v-timeline dense>
          <v-timeline-item
            v-for="(step, index) in tutorial.steps"
            :key="step.title"
            color="primary"
            large
          >
            <template v-slot:icon>
              <span class="font-weight-bold title">{{ index+1 }}</span>
            </template>
            <v-card class="elevation-2">
              <v-card-title :id="step.title">
                {{ step.title }}
              </v-card-title>
              <v-card-text>
                <!-- eslint-disable vue/no-v-html-->
                <div v-html="step.text" />
                <!-- eslint-enable -->
                <div v-if="step.video">
                  <p class="title">
                    Zobacz to na wideo:
                  </p>
                  <video
                    controls
                    width="50%"
                    style="display:block; margin: 0 auto;"
                    :poster="step.poster ? `${publicPath}video/${$route.params.tutorial}/${step.poster}`: undefined"
                  >
                    <source
                      :src="`${publicPath}video/${$route.params.tutorial}/${step.video}`"
                      type="video/webm"
                    >
                    <!-- <source src="https://storage.googleapis.com/webfundamentals-assets/videos/chrome.mp4" type="video/mp4"> -->
                    <p>Twoja przeglądarka nie obsługuje elementu video.</p>
                  </video>
                </div>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'

export default {
  name: 'EServiceTimeline',
  data: () => ({
    publicPath: process.env.BASE_URL,
    tutorial: undefined
  }),
  created () {
    axios
      .get(`${this.publicPath}api/${this.$route.params.tutorial}.json`)
      .then(response => (this.tutorial = response.data))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
</style>
